import React from "react";

import Box from "../Box";

import styled from "styled-components";
import BaseDashboardCard from "../BaseDashboardCard";
import useBreakPoint from "../../utils/useBreakPoint";
import SubTornover from "../SubTurnover/SubTurnover";
import { DriveObjective, DriveTurnover } from "../../types/drive";
import { computeRHRate } from "../../utils/turnover";
import { useTranslation } from "react-i18next";

type DriveTurnoverCardProps = {
  title: string;
  currentTotalData: DriveTurnover;
  pastTotalData: DriveTurnover;
  driveObjective: DriveObjective;
  isUnavailableTotal: boolean;
  isLoadingTotal: boolean;
  openInformationModal: (title?: string) => void;
};

const BoxCustom = styled(Box)<{ gap: string }>`
  gap: ${(props) => props.gap};
  display: flex;
`;
const DriveTurnoverCard = ({
  title,
  currentTotalData,
  pastTotalData,
  driveObjective,
  isLoadingTotal,
  isUnavailableTotal,
  ...res
}: DriveTurnoverCardProps) => {
  const isBreak = useBreakPoint();
  const totalRHRate = computeRHRate(
    currentTotalData?.turnover as number,
    pastTotalData?.turnover as number
  );

  const {t}=useTranslation();

  return (
    <BaseDashboardCard
      hasModal={true}
      title={title}
      size={"big"}
      isLoading={isLoadingTotal}
      isUnavailable={isUnavailableTotal}
      importedDateTime={currentTotalData?.importedDateTime}
      {...res}
    >
      <BoxCustom
        gap={`${isBreak === "phone" ? "12px" : "2rem"}`}
        flexDirection={"column"}
        width="100%"
        borderRadius={1}
        pt={[1, 4]}
      >
        <Box width={"100%"}>
          <SubTornover
            title={t('ecommerce.ca_total_facture')}
            target={driveObjective?.objectiveAmount}
            value={currentTotalData?.turnover}
            rate={totalRHRate as number}
            showProgressBar={false}
            objectiveLabel={t('ecommerce.objectif_drive_n1')}
          />
        </Box>
      </BoxCustom>
    </BaseDashboardCard>
  );
};

export default DriveTurnoverCard;
